import { Routes } from '@angular/router';
import {CheckInComponent} from "./components/check-in/check-in.component";
import {LoginComponent} from "./components/login/login.component";
import {CheckinSuccessComponent} from "./components/checkin-success/checkin-success.component";

export const routes: Routes = [
  {path: '', component: CheckInComponent},
  {path: 'login', component: LoginComponent},
  {path: 'checkin-success', component: CheckinSuccessComponent},
  {path: '**', redirectTo: ''}
];
